"use client";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HeaderDesktop from "./Desktop/HeaderDesktop";
import HeaderMobile from "./Mobile/HeaderMobile";

const Header = () => {
  // Detect mobile devices
  const isMobile = useMediaQuery({ maxWidth: 768 });
  
  // Sticky Navbar
  const [sticky, setSticky] = useState(false);
  const handleStickyNavbar = () => {
    if (window.scrollY >= 80) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };
  
  useEffect(() => {
    window.addEventListener("scroll", handleStickyNavbar);
    return () => {
      window.removeEventListener("scroll", handleStickyNavbar);
    };
  }, []);

  return (
    <header
      className={`header left-0 top-0 z-40 flex w-full items-center ${
        sticky
          ? "dark:bg-gray-dark dark:shadow-sticky-dark fixed z-[9999] bg-white !bg-opacity-80 shadow-sticky backdrop-blur-sm transition"
          : "absolute bg-transparent"
      }`}
    >
      {isMobile ? (
        <HeaderMobile sticky={sticky} />
      ) : (
        <HeaderDesktop sticky={sticky} />
      )}
    </header>
  );
};

export default Header;